import { inject, Injectable } from '@angular/core';
import { ApiRouteDepartmentService } from '../../../api/elite/routes/department.service';
import { Observable, of } from 'rxjs';
import { Department } from '../../../api/elite/types/department';
import { map, tap } from 'rxjs/operators';
import { DepartmentApiDto } from '../../../api/elite/dto/department.dto';
import { HosesDepartmentService } from '@dep-hoses/services';
import { WorkShift } from '../../../api/backend/types/work-shift';

@Injectable({
  providedIn: 'root',
})
export class HosesDepartmentApiService {
  private readonly apiDepartmentRouter = inject(ApiRouteDepartmentService);
  private readonly departmentService = inject(HosesDepartmentService);

  dataV2(
    data: DepartmentApiDto['dataV2']['params'] = {}
  ): Observable<Department> {
    return this.apiDepartmentRouter.getDataV2(
      this.departmentService.NAME,
      data
    );
  }

  getShifts(): Observable<WorkShift[]> {
    return this.apiDepartmentRouter.getShifts(
      this.departmentService.departmentId
    );
  }

  getDepartment(): Observable<Department> {
    return this.apiDepartmentRouter
      .getOneByName(this.departmentService.NAME)
      .pipe(tap((dep) => (this.departmentService.departmentId = dep.id)));
  }

  getDepartmentName(): string {
    return this.departmentService.NAME;
  }

  getDepartmentId(): Observable<number> {
    const departmentId = this.departmentService.departmentId;
    return departmentId
      ? of(departmentId)
      : this.getDepartment().pipe(map((d) => d.id));
  }
}
